import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DatabaseEmptyImg = function DatabaseEmptyImg(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/_jsxs("svg", {
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("circle", {
        id: _id,
        cx: "75",
        cy: "75",
        r: "75"
      })
    }), /*#__PURE__*/_jsx("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        transform: "translate(-744, -319)",
        children: /*#__PURE__*/_jsxs("g", {
          transform: "translate(744, 319)",
          children: [/*#__PURE__*/_jsx("rect", {
            x: "0",
            y: "0",
            width: "160",
            height: "160"
          }), /*#__PURE__*/_jsxs("g", {
            transform: "translate(10, 10)",
            children: [/*#__PURE__*/_jsx("ellipse", {
              fill: "#0181FD",
              fillRule: "nonzero",
              cx: "75",
              cy: "74.9666508",
              rx: "75",
              ry: "74.9666508"
            }), /*#__PURE__*/_jsxs("g", {
              transform: "translate(-0, 0)",
              children: [/*#__PURE__*/_jsx("mask", {
                id: _id2,
                fill: "white",
                children: /*#__PURE__*/_jsx("use", {
                  xlinkHref: "#".concat(_id)
                })
              }), /*#__PURE__*/_jsx("g", {}), /*#__PURE__*/_jsx("ellipse", {
                fill: "#349AFD",
                fillRule: "nonzero",
                mask: "url(#".concat(_id2, ")"),
                cx: "75",
                cy: "158.588942",
                rx: "133.855186",
                ry: "57.0685463"
              })]
            }), /*#__PURE__*/_jsx("ellipse", {
              fill: "#132039",
              fillRule: "nonzero",
              cx: "70.3033268",
              cy: "116.044268",
              rx: "44.3248532",
              ry: "10.7095215"
            }), /*#__PURE__*/_jsxs("g", {
              transform: "translate(35.225, 33.889)",
              fillRule: "nonzero",
              children: [/*#__PURE__*/_jsxs("g", {
                transform: "translate(0, 52.374)",
                children: [/*#__PURE__*/_jsxs("g", {
                  children: [/*#__PURE__*/_jsx("ellipse", {
                    fill: "#07C846",
                    cx: "39.7749511",
                    cy: "29.7812722",
                    rx: "39.62818",
                    ry: "10.7095215"
                  }), /*#__PURE__*/_jsx("rect", {
                    fill: "#07C846",
                    x: "0",
                    y: "10.7095215",
                    width: "79.4031311",
                    height: "19.0717507"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#07C846",
                    cx: "39.7749511",
                    cy: "10.7095215",
                    rx: "39.62818",
                    ry: "10.7095215"
                  }), /*#__PURE__*/_jsx("path", {
                    d: "M39.7749511,19.2184565 C18.0528376,19.2184565 2.93542074,14.5238717 2.93542074,10.1226984 C2.93542074,5.72152521 18.0528376,1.1736462 39.7749511,1.1736462 C61.4970646,1.1736462 76.6144814,5.86823098 76.6144814,10.2694042 C76.6144814,14.6705775 61.4970646,19.2184565 39.7749511,19.2184565 Z",
                    fill: "#132039"
                  })]
                }), /*#__PURE__*/_jsx("ellipse", {
                  fill: "#FFFFFF",
                  cx: "51.369863",
                  cy: "28.7543318",
                  rx: "2.93542074",
                  ry: "2.93411549"
                }), /*#__PURE__*/_jsx("ellipse", {
                  fill: "#FFFFFF",
                  cx: "60.6164384",
                  cy: "27.5806856",
                  rx: "2.93542074",
                  ry: "2.93411549"
                }), /*#__PURE__*/_jsx("ellipse", {
                  fill: "#FFFFFF",
                  cx: "68.6888454",
                  cy: "25.6735105",
                  rx: "2.93542074",
                  ry: "2.93411549"
                })]
              }), /*#__PURE__*/_jsxs("g", {
                transform: "translate(0, 26.2603)",
                children: [/*#__PURE__*/_jsxs("g", {
                  children: [/*#__PURE__*/_jsx("ellipse", {
                    fill: "#FFFFFF",
                    cx: "39.7749511",
                    cy: "29.7812722",
                    rx: "39.62818",
                    ry: "10.7095215"
                  }), /*#__PURE__*/_jsx("rect", {
                    fill: "#FFFFFF",
                    x: "0",
                    y: "10.7095215",
                    width: "79.4031311",
                    height: "19.0717507"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#FFFFFF",
                    cx: "39.7749511",
                    cy: "10.7095215",
                    rx: "39.62818",
                    ry: "10.7095215"
                  }), /*#__PURE__*/_jsx("path", {
                    d: "M39.7749511,19.0717507 C18.0528376,19.0717507 2.93542074,14.3771659 2.93542074,9.97599267 C2.93542074,5.72152521 18.0528376,0.880234647 39.7749511,0.880234647 C61.4970646,0.880234647 76.6144814,5.57481943 76.6144814,9.97599267 C76.6144814,14.3771659 61.4970646,19.0717507 39.7749511,19.0717507 Z",
                    fill: "#132039"
                  })]
                }), /*#__PURE__*/_jsx("ellipse", {
                  fill: "#E6E6E6",
                  cx: "51.369863",
                  cy: "29.7812722",
                  rx: "2.93542074",
                  ry: "2.93411549"
                }), /*#__PURE__*/_jsx("ellipse", {
                  fill: "#E6E6E6",
                  cx: "60.6164384",
                  cy: "28.4609203",
                  rx: "2.93542074",
                  ry: "2.93411549"
                }), /*#__PURE__*/_jsx("ellipse", {
                  fill: "#E6E6E6",
                  cx: "68.6888454",
                  cy: "26.5537452",
                  rx: "2.93542074",
                  ry: "2.93411549"
                })]
              }), /*#__PURE__*/_jsxs("g", {
                children: [/*#__PURE__*/_jsxs("g", {
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M0,10.7095215 L0,29.7812722 C0,35.6495032 17.7592955,40.4907938 39.62818,40.4907938 C61.4970646,40.4907938 79.2563601,35.6495032 79.2563601,29.7812722 L79.2563601,10.7095215 L0,10.7095215 Z",
                    fill: "#FFFFFF"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#FFFFFF",
                    cx: "39.7749511",
                    cy: "10.7095215",
                    rx: "39.62818",
                    ry: "10.7095215"
                  }), /*#__PURE__*/_jsx("path", {
                    d: "M39.7749511,18.9250449 C18.0528376,18.9250449 2.93542074,14.2304601 2.93542074,9.8292869 C2.93542074,5.57481943 18.0528376,0.733528873 39.7749511,0.733528873 C61.4970646,0.733528873 76.6144814,5.42811366 76.6144814,9.8292869 C76.6144814,14.0837544 61.4970646,18.9250449 39.7749511,18.9250449 Z",
                    fill: "#E6E6E6"
                  })]
                }), /*#__PURE__*/_jsx("ellipse", {
                  fill: "#E6E6E6",
                  cx: "51.369863",
                  cy: "30.8082127",
                  rx: "2.93542074",
                  ry: "2.93411549"
                }), /*#__PURE__*/_jsx("ellipse", {
                  fill: "#E6E6E6",
                  cx: "60.6164384",
                  cy: "29.6345665",
                  rx: "2.93542074",
                  ry: "2.93411549"
                }), /*#__PURE__*/_jsx("ellipse", {
                  fill: "#E6E6E6",
                  cx: "68.6888454",
                  cy: "27.7273914",
                  rx: "2.93542074",
                  ry: "2.93411549"
                })]
              })]
            }), /*#__PURE__*/_jsxs("g", {
              transform: "translate(20.2544, 20.6855)",
              fill: "#FFA005",
              fillRule: "nonzero",
              children: [/*#__PURE__*/_jsx("path", {
                d: "M108.023483,9.38916957 C105.234834,7.92211183 102.739726,4.54787901 101.565558,0.586823098 C101.418787,0.293411549 101.125245,0 100.831703,0 C100.53816,0 100.244618,0.293411549 100.097847,0.586823098 C98.9236791,4.54787901 96.4285714,7.77540605 93.6399217,9.38916957 C93.3463796,9.53587535 93.1996086,9.8292869 93.1996086,10.1226984 C93.1996086,10.41611 93.3463796,10.7095215 93.6399217,10.8562273 C96.4285714,12.3232851 98.9236791,15.6975179 100.097847,19.6585738 C100.244618,19.9519853 100.53816,20.2453969 100.831703,20.2453969 C101.125245,20.2453969 101.418787,19.9519853 101.565558,19.6585738 C102.739726,15.6975179 105.234834,12.4699908 108.023483,10.8562273 C108.317025,10.7095215 108.463796,10.41611 108.463796,10.1226984 C108.463796,9.8292869 108.170254,9.53587535 108.023483,9.38916957 Z"
              }), /*#__PURE__*/_jsx("path", {
                d: "M20.2544031,68.0714794 C16.4383562,66.0175986 12.9158513,61.4697195 11.4481409,56.1883117 C11.3013699,55.7481943 10.8610568,55.4547828 10.4207436,55.4547828 C9.98043053,55.4547828 9.54011742,55.7481943 9.39334638,56.1883117 C7.77886497,61.4697195 4.40313112,66.0175986 0.587084149,68.0714794 C0.293542074,68.2181852 0,68.5115967 0,68.951714 C0,69.3918314 0.146771037,69.6852429 0.587084149,69.8319487 C4.40313112,71.8858295 7.92563601,76.4337086 9.39334638,81.7151164 C9.54011742,82.1552338 9.98043053,82.4486453 10.4207436,82.4486453 C10.8610568,82.4486453 11.3013699,82.1552338 11.4481409,81.7151164 C13.0626223,76.4337086 16.4383562,71.8858295 20.2544031,69.8319487 C20.5479452,69.6852429 20.8414873,69.2451256 20.8414873,68.951714 C20.8414873,68.5115967 20.5479452,68.2181852 20.2544031,68.0714794 Z"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            children: [/*#__PURE__*/_jsx("g", {
              fill: "#07C846",
              children: /*#__PURE__*/_jsx("ellipse", {
                cx: "26.5959328",
                cy: "26.5841035",
                rx: "26.5959328",
                ry: "26.5841035"
              })
            }), /*#__PURE__*/_jsx("path", {
              d: "M40.1768347,23.331793 L29.8496905,23.331793 L29.8496905,13.0092421 C29.8496905,12.0194085 29.0008842,11.0295749 27.8691424,11.0295749 L25.1812555,11.0295749 C24.1909814,11.0295749 23.2007073,11.8780037 23.2007073,13.0092421 L23.2007073,23.331793 L12.8735632,23.331793 C11.8832891,23.331793 10.893015,24.1802218 10.893015,25.3114603 L10.893015,27.9981516 C10.893015,28.9879852 11.7418214,29.9778189 12.8735632,29.9778189 L23.2007073,29.9778189 L23.2007073,40.3003697 C23.2007073,41.2902033 24.0495137,42.280037 25.1812555,42.280037 L27.8691424,42.280037 C28.8594164,42.280037 29.8496905,41.4316081 29.8496905,40.3003697 L29.8496905,29.9778189 L40.1768347,29.9778189 C41.1671088,29.9778189 42.1573828,29.12939 42.1573828,27.9981516 L42.1573828,25.3114603 C42.1573828,24.1802218 41.3085765,23.331793 40.1768347,23.331793 Z",
              fill: "#FFFFFF",
              fillRule: "nonzero"
            })]
          })]
        })
      })
    })]
  });
};
if (process.env.NODE_ENV !== 'production') {
  DatabaseEmptyImg.displayName = 'DatabaseEmptyImg';
}
export default DatabaseEmptyImg;